module.exports = __webpack_public_path__ + "static/img/13xunhuanliyong.f2beeed2.gif";